<div #player class="custom-audio-player">
  <div #timeline (click)="timelineClick($event)" class="timeline">
    <div #progressBar class="progress"></div>
  </div>
  <div class="controls">
    <div>
      <div class="play-container">
        <div #tooglePlayEl (click)="tooglePlay()" class="toggle-play play"></div>
      </div>

      <div class="time">
        <div class="current">0:00</div>
        <div class="divider">/</div>
        <div class="length"></div>
      </div>
    </div>

    <div class="volume-container">
      <div (click)="volumeClick()" class="volume-button">
        <div #volume class="volume">
          <i *ngIf="audio?.muted" class="pi pi-volume-off"></i>
          <i *ngIf="!audio?.muted" class="pi pi-volume-up"></i>
        </div>
      </div>

      <div #volumeSlider (click)="volumeSliderClick($event)" class="volume-slider">
        <div #volumePercentage class="volume-percentage"></div>
      </div>
    </div>
  </div>
</div>
